
import { useState,useEffect } from "react";

import axios from "axios";

import MainLayout from "../layouts/MainLayout";

import AddClientTicket from "./AddClientTicket";

import AddTicket from "./AddTicket";

function Tickets(){

const [tickets,setTickets]=useState([]);

const [search,setSearch]=useState("");

const [showAddDialog,
setShowAddDialog]=useState(false);

const role=
localStorage.getItem("role_id");

useEffect(()=>{

loadTickets();

},[]);

useEffect(()=>{

if(showAddDialog){

const handleEsc=(e)=>{

if(e.key==="Escape"){

setShowAddDialog(false);

}

};

window.addEventListener(
"keydown",
handleEsc
);

return()=>{

window.removeEventListener(
"keydown",
handleEsc
);

};

}

},[showAddDialog]);

const loadTickets=async()=>{

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.get(

"https://saleupcall.com/api/Ticket/get-tickets.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setTickets(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const filteredTickets=

tickets.filter(

(ticket)=>

(ticket.ticket_number || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.client_name || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.manager_name || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.technician_name || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.title || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.priority || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

||

(ticket.status || "")
.toLowerCase()
.includes(
search.toLowerCase()
)

);

const deleteTicket=async(id)=>{

if(
!window.confirm(
"Delete this ticket?"
)
){
return;
}

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/delete-ticket.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert("Deleted");

loadTickets();

}

}
catch(error){

console.log(error);

}

};

const printTable=()=>{

window.print();

};

return(

<MainLayout>

<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>Tickets</h4>

</div>

<div className="col-md-6 d-print-none">

<input

type="text"

className="form-control form-control-sm"

placeholder="Search Ticket"

value={search}

onChange={(e)=>
setSearch(
e.target.value
)
}

/>

</div>

<div className="col-md-2 d-flex gap-1">

<button

className="btn btn-success btn-sm w-50 d-print-none"

onClick={()=>
setShowAddDialog(true)
}
>

<i className="bi bi-plus-lg"></i>

</button>

<button

className="btn btn-secondary btn-sm w-50 d-print-none"

onClick={printTable}

>

<i className="bi bi-printer"></i>

</button>

</div>

</div>

<div className="table-responsive">

<table className="table table-bordered table-hover table-striped table-sm">

<thead className="table-success">

<tr>

<th>ID</th>

<th>Created</th>

<th>Ticket No</th>

<th>Client</th>

<th>Title</th>

<th>Manager</th>

<th>Technician</th>

<th>Priority</th>

<th>Status</th>

<th width="120">

Actions

</th>

</tr>

</thead>

<tbody>

{

filteredTickets.map(

(ticket)=>(

<tr key={ticket.id}>

<td>

{ticket.id}

</td>

<td>

{ticket.created_at}

</td>

<td>

{ticket.ticket_number}

</td>

<td>

{ticket.client_name}

</td>

<td>

{ticket.title}

</td>

<td>

{ticket.manager_name || "-"}

</td>

<td>

{ticket.technician_name || "-"}

</td>

<td>

<span className="badge bg-warning text-dark">

{ticket.priority}

</span>

</td>

<td>

<span className="badge bg-info">

{ticket.status}

</span>

</td>

<td>

<button

className="btn btn-danger btn-sm"

onClick={()=>
deleteTicket(ticket.id)
}
>

<i className="bi bi-trash"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{
showAddDialog && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-lg">

<div className="modal-content">

<div className="modal-header">

<h5>Create Ticket</h5>

<button
className="btn-close"
onClick={()=>
setShowAddDialog(false)
}
>
</button>

</div>

<div className="modal-body">

{
role === "4"
?
(

<AddClientTicket

onClose={()=>{

setShowAddDialog(false);

loadTickets();

}}

/>

)
:
(

<AddTicket

onClose={()=>{

setShowAddDialog(false);

loadTickets();

}}

/>

)

}

</div>

</div>

</div>

</div>

)

}

</MainLayout>

);

}

export default Tickets;
